const config = {
  test: {
    apiUrl: "/api",
    serverUrl: "https://localhost:44358",
    loginUrl: "https://localhost:44360/Login",
    //},
    //apiUrl: "https://localhost:5001/api",
    //serverUrl: "https://localhost:5001"
  },
  development: {
    apiUrl: "https://uat-rates.ceylonexchange.com.au/RateCal/api",
    serverUrl: "https://uat-rates.ceylonexchange.com.au/RateCal",
    loginUrl: "https://uat-rates.ceylonexchange.com.au/RateCal/Login",
  },
  production: {
    // Relative to the current origin so the same build works on any host
    // (uat-rates.ceylonexchange.com.au, rates.ceylonexchange.com.au, etc.)
    // without being rebuilt per environment.
    apiUrl: "/RateCal/api",
    serverUrl: "/RateCal",
    loginUrl: "/RateCal/Login",
  },
  uat: {
    apiUrl: "http://18.219.149.204:80/App/api",
  },
};

exports.get = function get(env) {
  return config[env] || config.development;
};
